// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\RouteProtection.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\RouteProtection.tsx");
  import.meta.hot.lastModified = "1759761980430.1548";
}
// REMIX HMR END

import { useEffect } from "react";
import { useNavigate, useLocation } from "@remix-run/react";
import { isAuthenticated } from "~/lib/api";
export function RouteProtection({
  children,
  requireAuth = true
}) {
  _s();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    // Check authentication after component mounts to ensure localStorage is available
    const checkAndRedirect = () => {
      const authenticated = isAuthenticated();
      if (requireAuth && !authenticated) {
        // User needs to be logged in but isn't - redirect to login
        navigate("/login");
      } else if (!requireAuth && authenticated) {
        // User shouldn't be on this page when logged in - redirect to home
        navigate("/home");
      }
    };

    // Run the check immediately and also after a small delay to catch any async updates
    checkAndRedirect();
    const timeout = setTimeout(checkAndRedirect, 100);
    return () => clearTimeout(timeout);
  }, [requireAuth, navigate, location.pathname]);

  // Check authentication for rendering
  const authenticated = isAuthenticated();

  // Don't render anything during redirect
  if (requireAuth && !authenticated) {
    return null;
  }
  if (!requireAuth && authenticated) {
    return null;
  }
  return <>{children}</>;
}

// Wrapper for protected routes that require authentication
_s(RouteProtection, "gMsdikdDs1f1NUVrv3Ag60oK04k=", false, function () {
  return [useNavigate, useLocation];
});
_c = RouteProtection;
export function ProtectedRoute({
  children
}) {
  return <RouteProtection requireAuth={true}>{children}</RouteProtection>;
}

// Wrapper for public routes that should redirect if user is logged in
_c2 = ProtectedRoute;
export function PublicRoute({
  children
}) {
  return <RouteProtection requireAuth={false}>{children}</RouteProtection>;
}
_c3 = PublicRoute;
var _c, _c2, _c3;
$RefreshReg$(_c, "RouteProtection");
$RefreshReg$(_c2, "ProtectedRoute");
$RefreshReg$(_c3, "PublicRoute");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;